import React, {useCallback, useState} from 'react';
import Icon from '@/components/icons/Icon';

interface Props {
    query: string;
}

const QueryCopyButton = React.memo<Props>(({query}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = useCallback(async () => {
        if (!query) {
            return;
        }

        try {
            await navigator.clipboard.writeText(query);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
        } catch {
            setCopied(false);
        }
    }, [query]);

    if (!query) {
        return null;
    }

    return (
        <button
            type="button"
            className="query-help-modal__copy-btn"
            onClick={handleCopy}
            title="Copy query"
        >
            <Icon name={copied ? 'mdi-check' : 'mdi-content-copy'} size="14px" />
            {copied ? 'Copied' : 'Copy'}
        </button>
    );
});

export default QueryCopyButton;
